/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateEquipmentSettingCommand } from '../../models/update-equipment-setting-command';
import { UpdateEquipmentSettingCommandResult } from '../../models/update-equipment-setting-command-result';

export interface ApiEquipmentSettingUpdateEquipmentSettingPut$Params {
  
    /**
     * The command containing the updated details for the equipment setting.
     */
    body?: UpdateEquipmentSettingCommand
}

export function apiEquipmentSettingUpdateEquipmentSettingPut(http: HttpClient, rootUrl: string, params?: ApiEquipmentSettingUpdateEquipmentSettingPut$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateEquipmentSettingCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiEquipmentSettingUpdateEquipmentSettingPut.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateEquipmentSettingCommandResult>;
    })
  );
}

apiEquipmentSettingUpdateEquipmentSettingPut.PATH = '/api/EquipmentSetting/UpdateEquipmentSetting';
